// tslint:disable:variable-name
import { ViewEncapsulation, Component, EventEmitter, Input, ElementRef, Output, AfterViewInit } from '@angular/core';
import { UtilitiesService } from './../../services/utilities.service';
import * as VMasker from 'vanilla-masker';

@Component({
    selector: 'monitored-data-input',
    templateUrl: './monitored-data-input.component.html',
    styleUrls: [ './monitored-data-input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class MonitoredDataInputComponent implements AfterViewInit {

    /** Evento disparado quando o valor do componente começa a ser editado */
    @Output() public onEditingStart: EventEmitter<{}> = new EventEmitter<{}>();

    /** Evento disparado quando o valor do evento termina de ser editado (onblur) */
    @Output() public onEditingEnd: EventEmitter<{}> = new EventEmitter<{}>();

    @Output() public onValueChange: EventEmitter<number> = new EventEmitter<number>();

    @Output() public onUserEditRequest: EventEmitter<{}> = new EventEmitter<{}>();

    /** Icone a ser usado no controle para habilitar edição */
    @Input() public set editControlIcon(icon: string) {
        this._editControlIcon = icon;
    }

    /** Icone a ser usado no controle para desabilitar edição */
    @Input() public set stopEditControlIcon(icon: string) {
        this._stopEditControlIcon = icon;
    }

    /** Habilitar ou desabilitar os controles de edição */
    @Input() public set controls(value: boolean) {
        this._enableEditingControls = value;
    }

    /** Valor corrente do componente */
    @Input() public get value() {
        return this._value;
    }
    public set value(value: number) {
        if (this._touchedCount === 0) {
            this._touchedCount += 1;
            this._initialValue = value;
            this._value = value;
        }
        this._value = value;
        this._touchedCount += 1;
        this.onValueChange.emit(value);
    }

    /** Já foi executado */
    @Input() public set executed(value: boolean) {
        this._executed = value;
    }
    /** Está criando um planejamento */
    @Input() public set planning(value: boolean) {
        this._planning = value;
    }

    @Input() public set type(value: 'gain' | 'stop' | 'default' ) {
        this._type = value;
    }

    public get componentType() {
        return 'monitored-data-input--' + this._type;
    }

    public get inputElement() {
        return  $(this.element.nativeElement)
            .find('input');
    }

    /** Label do componente (bottom) */
    @Input() public set bottomLabel(label: string) {
        this._bottomLabel = label;
    }

    /** Label do componente (bottom) */
    @Input() public set lock(value: boolean) {
        if (!value) {
            this.enableEditing();
        } else {
            this.disableEditing();
        }
    }
    public get lock() {
        return this._locked;
    }

    /** Label baseado no tipo de component */
    public get getInputLabel(): string {
        let labelContent = 'ou <span class="popover-link">perder</span> aprox.';

        if (this._type === `default`) {
            labelContent = 'Quero investir aprox.';
        }

        if (this._type === `default` && this._executed) {
            labelContent = `Estou investindo`;
        }

        if (this._type === 'gain') {
            if (!this._planning) {
                labelContent =  'Para <span class="popover-link">ganhar</span> aprox.';
            } else {
                labelContent = 'Quero <span class="popover-link">ganhar</span> aprox.';
            }

        }

        return labelContent;
    }

    /** Definições da máscara */
    public maskOptions = { prefix: 'R$ ', suffix: ' ', thousands: '.', decimal: ',', align: 'left' };
    /** Desabilitado para edição */
    public _locked: boolean = true;
    /** Label inferior do componente */
    public _bottomLabel: string;
    /** Habilitar controles de edição */
    public _enableEditingControls: boolean = true;
    /** Ícone a ser usado para o controle de edição (iniciar) */
    public _editControlIcon: string = 'icon_edit';
    /** Ícone a ser usado para o controle de edição (finalizar) */
    public _stopEditControlIcon: string = 'icon_cross';
    /** Indica o número de vezes que o componente já foi tocado */
    private _touchedCount: number = 0;
    /** Valor anterior ao início da edição */
    private _previousValue: number;
    /** Classificação do componente */
    private _type: 'stop' | 'gain' | 'default' = 'default';
    /* Valor do componente */
    private _value: number;
    /* Valor inicial do componente */
    private _initialValue: number;
    /* Variável que controla a quantidade de vezes que o input foi desbloqueado */
    private _unlockedCount: number = 0;
    private _executed: boolean;
    private _planning: boolean;

    constructor(
        private element: ElementRef,
        private utilitiesService: UtilitiesService,
    ) {
        this.disableEditing();
    }

    /* Habilita edição do valor do componente */
    public enableEditing(): void {
        this._touchedCount += 1;
        this._previousValue = this._value;
        this.onEditingStart.emit(this.getCurrentComponentState());
        this.inputElement.focus();
        this._locked = false;
        this._unlockedCount += 1;
    }

    /* Desabilita a edição do valor do componente */
    public disableEditing(): void {
        // this._previousValue = this.getOnlyNumbers(this._value);
        this.onEditingEnd.emit(this.getCurrentComponentState());
        this.inputElement.blur();
        this._locked = true;
    }

    /** Retorna o stado atual do componente */
    public getCurrentComponentState(event: Event = null): {} {
        return {
            touchedBefore: this._touchedCount > 2,
            touchs: this._touchedCount,
            previousValue: this._previousValue,
            currentValue: this._value,
            originalEvent: event,
            initialValueModified: this._initialValue !== this._value,
            previousUnlocked: this._unlockedCount > 0,
            modified: this._previousValue !== this._value,
        };
    }

    /** Edição finalizada */
    public onComponentEditingEnd(event: Event) {

        this.disableEditing();
        this.onEditingEnd.emit(this.getCurrentComponentState());
        this.inputElement.blur();
    }

    public ngAfterViewInit() {
        /** Inicializa e mostra a tooltip quando o usuário posiciona o mouse sobre o label (no span) */
        $(this.element.nativeElement)
            .on('mouseenter', '.popover-link', (e) => {
                if ($(e.currentTarget)
                    .attr('data-tooltip-initialized') === 'true') return;

                $(e.currentTarget)
                    .attr('data-tooltip-initialized', 'true');
                const tooltip = this.utilitiesService.bindTooltipContent(e.currentTarget, this.getTooltipContent());
                tooltip.show();
            });
        }

    /** Remove os valores não numéricos da string de formato R$ 9.009,00 */
    public getOnlyNumbers(value: string): number {
        if (!value)  return 0;
        if (typeof value === 'number') return value;
        const numberValue = value.toString()
            .replace(/[^0-9]/g, '');
        return value.indexOf('R$') !== -1 ? + numberValue / 100 : + numberValue;
    }

    /** Handler para o evento de keypress na input do componente */
    public onKeyPress(event: Event) {
        if (this._locked) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
    }

    /** Retorna o conteúdo da tooltip usada no label de acordo com o tipo do component. */
    public getTooltipContent() {
        let tooltipContent = `<div>
                <div class='pop-title'>{{title}}</div>
                <div class='pop-content'>{{content}}</div>
            </div>`;

        if (this._type === 'gain') {
            tooltipContent = tooltipContent.replace('{{title}}', 'Ganhar');
            tooltipContent = tooltipContent.replace('{{content}}', 'O investimento encerra automaticamente quando alcançar o lucro planejado.');
        } else {
            tooltipContent = tooltipContent.replace('{{title}}', 'Perder');
            tooltipContent = tooltipContent.replace(
                '{{content}}',
                'O investimento encerra automaticamente quando alcançar o prejuízo planejado.',
            );
        }

        return tooltipContent;
    }

    /**
     * Handler para quando o usuário clica na input solicitando edição
     * e a input está bloqueada para edição
     */
    public editRequestHandler(event: Event) {
        if ( this._type !== 'default' && this._enableEditingControls || this._type === 'default') {
            this.onUserEditRequest.emit(this.getCurrentComponentState(event));
        } else {
            event.preventDefault();
            $(event.target)
                .blur();
        }

        this._touchedCount += 1;
    }

}
